/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['model/objectModel'], function(ObjectModel) {
    'use strict';
    var SIMPLE_PROPERTIES = [
        'categories',
        'classifications',
        'name',
        'phone',
        'url'
    ];

    var PoiModel = function(json) {
        SIMPLE_PROPERTIES.forEach(function(property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);

        return this;
    };
    PoiModel.prototype = Object.create(ObjectModel.prototype);
    PoiModel.prototype.constructor = PoiModel;

    return PoiModel;
});



// WEBPACK FOOTER //
// ./model/search/poiModel.js